import { render, staticRenderFns } from "./permisosIndex.vue?vue&type=template&id=65fc7835&scoped=true"
import script from "./permisosIndex.vue?vue&type=script&lang=js"
export * from "./permisosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc7835",
  null
  
)

export default component.exports